import React from 'react';
import { useField } from 'formik';
import Input from '../../../../src/Components/Common/common/src/input/Input';
import _handleStatusFormik from '../../../Helpers/StatusFormik';

const InputFormik = (props) => {
    const [field, meta, helpers] = useField(props);
    // Creo un objeto donde le paso las props de formik y las props del Input para enviarlas al state del mismo
    const obj = { ...meta, ...props };
    return <Input {...field} {...props} state={!props.disabled ? _handleStatusFormik(obj) : null} ref={props.r} />;
};

export default InputFormik;
